// const convertPercent = (decimalNumber = 0) => {
//   var percentage = (decimalNumber * 100).toFixed(2) + "%";
//   return percentage;
// };

// export default convertPercent;


const convertPercent = (decimalNumber = 0) => {
  // Check if the number has decimal places
  const hasDecimals = decimalNumber % 1 !== 0;
  
  // If it has decimals, show one decimal place; if not, show whole number
  const percentage = hasDecimals 
    ? (decimalNumber * 100).toFixed(1) + "%"
    : (decimalNumber * 100) + "%";
    
  return percentage;
};

export default convertPercent;